import './component.scss'
import './images/top_search_client_outer_wall.svg'
import './images/top_search_client_mappin.svg'
import './images/hokkaido.webp'
import './images/hukuoka.webp'
import './images/kyoto.webp'
import './images/aichi.webp'
import './images/osaka.webp'
import './images/shizuoka.webp'
import './images/tokyo.webp'
import './images/kanagawa.webp'
import './images/ranking.svg'
import './images/top_search_client_nurikawa.png'
import TopSearchClientController from './controllers/top_search_client_controller'
import 'Components/nurikae/top_search_client/modal/component'

window.Stimulus.register('top-search-client', TopSearchClientController)

document.addEventListener('DOMContentLoaded', () => {
  document.getElementsByClassName('js-ChannelIO-openWorkflow').forEach(element => {
    element.addEventListener('click', () => {
      if (typeof window.ChannelIO === 'function') {
        window.ChannelIO('openWorkflow', element.dataset.channelId)
      } else {
        // ChannelIOが埋め込まれていない環境で正しく呼ばれていることを確認するためconsole.logを仕込む
        console.log(`call ChannelIO openWorkflow ${element.dataset.channelId}`)
      }
    })
  })
})
